"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trim = (str, char) => {
    return str.replace(new RegExp("^[" + char + "]+|[" + char + "]+$", "g"), "");
};



//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/utils/trim.js
// module id = 890
// module chunks = 113